import { Send } from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

const QUICK_TOPICS = [
  { label: "🎓 Admissions", text: "How do I apply to overseas universities?" },
  { label: "🧭 Career & Stream", text: "I need career and stream selection counselling." },
  { label: "📚 Find a Tutor", text: "Find me a verified tutor for class 10." },
  { label: "💬 WhatsApp Support", text: "What is your WhatsApp number and email?" },
];

/**
 * Composer row at the bottom of the chat widget with quick suggestion pills + input + send.
 */
export default function ChatComposer({ input, setInput, onSend, loading, onQuickPrompt }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  const handlePillClick = (text) => {
    if (onQuickPrompt) {
      onQuickPrompt(text);
    } else {
      setInput(text);
      if (onSend) onSend(text);
    }
  };

  return (
    <div className="border-t border-purple-100 bg-white px-3 py-2 space-y-1.5 shrink-0">
      <div className="flex items-center gap-1.5 overflow-x-auto no-scrollbar pb-1 text-xs">
        {QUICK_TOPICS.map((t) => (
          <button
            key={t.label}
            type="button"
            onClick={() => handlePillClick(t.text)}
            className="whitespace-nowrap rounded-full border border-purple-100 bg-purple-50/70 px-2.5 py-1 text-[11px] font-medium text-[#7C3AED] hover:bg-purple-100 hover:border-purple-300 transition-colors shadow-xs"
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask about admissions, counselling, tutors..."
          className="flex-1 rounded-full border-black/10 focus-visible:ring-[#7C3AED]"
          data-testid="askpurple-input"
        />
        <Button
          onClick={() => onSend()}
          disabled={loading || !input.trim()}
          className="h-10 w-10 rounded-full bg-gradient-to-br from-[#7C3AED] to-[#EC4899] p-0 text-white hover:opacity-90"
          data-testid="askpurple-send-btn"
          aria-label="Send"
        >
          <Send size={16} />
        </Button>
      </div>
    </div>
  );
}

